var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "select",
    {
      staticClass: "form-control select2",
      staticStyle: { width: "100%" },
      attrs: {
        multiple: _vm.multiple,
        required: _vm.required,
        "data-placeholder": _vm.placeholder,
      },
    },
    [
      !_vm.multiple ? _c("option", { attrs: { value: "" } }) : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.options, function (opt) {
        return _c(
          "option",
          { key: opt.value, domProps: { value: opt.value } },
          [_vm._v(_vm._s(opt.text))]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }